
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class UserPersonSharedService {

  private fetch = new BehaviorSubject(false);
  public _isArchived$ = new BehaviorSubject(false);
  sharedFetch = this.fetch.asObservable();

  constructor() { }

  fetchPersonHeadData(fetch: boolean) {
    this.fetch.next(fetch)
  }

  get isArchived$() { return this._isArchived$.asObservable(); }


}